import { useRef } from "react";

export const useScreenHeight = () => {
  const height = useRef<number>(window.innerHeight);

  return height.current;
};
